const codes = {
  failed: {
    code: 'failed',
    message: 'Ocorreu um erro no processamento da transação.'
  },
  receiver_account_invalid: {
    code: 'receiver_account_invalid',
    message: 'Agência, conta ou dígito verificador da conta inválido.'
  },
  receiver_account_blocked: {
    code: 'receiver_account_blocked',
    message: 'Conta bloqueada.'
  },
  receiver_account_closed: {
    code: 'receiver_account_closed',
    message: 'Conta do recebedor não existe ou foi encerrada.'
  },
  receiver_account_limit_exceeded: {
    code: 'receiver_account_limit_exceeded',
    message: 'Não foi possível realizar o pagamento, conta do recebedor tem limite de saldo mensal.'
  },
  receiver_account_not_allowed_payment: {
    code: 'receiver_account_not_allowed_payment',
    message: 'Transação não permitida, valor devolvido pelo banco do recebedor.'
  },
  receiver_institution_failure: {
    code: 'receiver_institution_failure',
    message: 'Ocorreu um erro no processamento da transação por parte do banco recebedor.'
  },
  receiver_institution_not_enabled: {
    code: 'receiver_institution_not_enabled',
    message: 'Instituição não habilitada para receber PIX.'
  },
  receiver_tax_id_divergent: {
    code: 'receiver_tax_id_divergent',
    message: 'CPF/CNPJ informado para pagamento diverge com o CPF/CNPJ do titular no Banco.'
  },
  receiver_institution_qrcode_rejected: {
    code: 'receiver_institution_qrcode_rejected',
    message: 'QR Code rejeitado pela instituição do recebedor.'
  },
  antifraud_refused: {
    code: 'antifraud_refused',
    message: 'Transação recusada por motivos de segurança. Em caso de dúvidas entre em contato com nosso suporte.'
  }
};

module.exports = codes;
